export const createTableData = (feature: string, stockpiles: object[] = []) => {
  return { feature, stockpiles };
};

export const sortStockpilesByDistance = (rowData: any) => {
  if (!rowData?.length) return rowData;
  const data = JSON.parse(JSON.stringify(rowData));

  return data
    .slice()
    .sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));
};

export const keysToUpperCase = (object: any) => {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [key.toUpperCase(), value])
  );
};

export const prepareTableRowsData = (data, stockpilesTableFeatures) => {
  const rowsData: any = [];
  // for now
  const tableData = keysToUpperCase(data);

  for (let i = 0; i < Object.keys(stockpilesTableFeatures).length; i++) {
    const row = sortStockpilesByDistance(
      tableData[Object.keys(stockpilesTableFeatures)[i]]
    );

    rowsData.push(
      createTableData(Object.values(stockpilesTableFeatures)[i] as string, row)
    );
  }

  return rowsData;
};

// get neededData from { __type: "sometype", data: [neededData]}
export const getResponseNextLevelData = (data: any) =>
  Object.values(data).filter((item) => typeof item !== "string");
